/**
 * Graph: an Obsidian-style map of how everything in Apiboo connects (Graph & Projects, 13.09.2026).
 * HOST-RENDERED (calendar precedent): the page is wired in App.js
 * (`activeTab === 'graph.panel'`) as a full-bleed view; entry.js is a no-op
 * kept for the registration contract. Records: extension_documents
 * (extension_id 'projects'), see src/graph/projectsStore.js.
 */
export const graphManifest = {
  schemaVersion: 1,
  id: 'com.apiboo.graph',
  name: 'Graph',
  version: '0.1.0',
  publisher: 'apiboo',
  entry: 'dist/main.js',
  icon: 'network',
  engines: { apibooSdk: '^1.0.0' },
  hostRendered: true,
  permissions: [],
  contributes: {
    activityBar: [{ id: 'graph.activity', title: 'Graph', icon: 'network', order: { after: 'projects.activity' } }],
    panels: [{ id: 'graph.panel', activityBarId: 'graph.activity', title: 'Graph' }],
    settings: [],
  },
};
